import { ActionObject } from '../../../../common/actions/actionTypes';
import { MNElement } from '../../../../common/elements/elementModelTypes';

// Action Types
export const HYBRID_ACTION_TYPES = {
    ELEMENT_EDIT_START: 'HYBRID_ELEMENT_EDIT_START',
    PRESENT_MODAL_IMAGE: 'HYBRID_PRESENT_MODAL_IMAGE',
    PRESENT_MODAL_PDF: 'HYBRID_PRESENT_MODAL_PDF',
    REDO: 'HYBRID_REDO',
    UNDO: 'HYBRID_UNDO',
    USER_NAVIGATE: 'HYBRID_USER_NAVIGATE',
} as const;

export interface HybridLocationChangeFileAction extends ActionObject {
    fileElement: MNElement;
    type: 'HYBRID_PRESENT_MODAL_PDF';
}

export interface HybridLocationChangeImageAction extends ActionObject {
    imageElement: MNElement;
    type: 'HYBRID_PRESENT_MODAL_IMAGE';
}

export interface HybridLocationChangeNavigationAction extends ActionObject {
    path: String;
    type: 'HYBRID_USER_NAVIGATE';
}

export interface HybridElementEditStartAction extends ActionObject {
    element: MNElement | undefined;
    relevantElements: Map<string, MNElement> | undefined;
    id?: string;
    editorKey?: string;
    type: 'HYBRID_ELEMENT_EDIT_START';
}
